import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsInsideMobileWebview } from "@circle-react/hooks/useIsInsideMobileWebview";
import type { ReactNode } from "react";

interface HeaderProps {
  children?: ReactNode;
  className?: string;
}

export const Header = ({ className, children }: HeaderProps) => {
  const isInsideWebview = useIsInsideMobileWebview();

  return (
    <div
      className={classNames(
        "text-dark border-primary sticky top-0 z-10 flex items-center justify-between border-b px-5 pb-2 pt-6 md:px-6 md:py-5",
        className,
        {
          "!p-0": isInsideWebview,
        },
      )}
    >
      <div className="flex w-full justify-between">{children}</div>
    </div>
  );
};
